export enum EActiveSubscriptionsConditionsFeature {
  /** Кабинет ГВ (грузовладельца) */
  cargoOwnerWorkplace = 'cargoOwnerWorkplace',
  /** Кабинет ГО/ГП (грузоотправитель/грузополучатель) */
  shipperWorkplace = 'shipperWorkplace',
  /** Кабинет ГП (грузоперевозчика) */
  carrierWorkplace = 'carrierWorkplace',
  /** Тендерный (стартовый) Кабинет ГП (грузоперевозчика) */
  baseCarrierWorkplace = 'baseCarrierWorkplace',
  /** Дополнительные фичи экспедитора */
  forwarderFeatures = 'forwarderFeatures',
  /** Калькулятор перевозки */
  priceCalculator = 'priceCalculator',
  /** Электронный документооборот */
  operationalDocuments = 'operationalDocuments',
  /** Геомониторинг */
  geomonitoring = 'geomonitoring',
  /** Настройки интеграции */
  integrationSettings = 'integrationSettings',
  /** Настройка автоматического назначения логистов на транспортные заказы */
  responsibleOnLookupAssignmentRules = 'responsibleOnLookupAssignmentRules',
}

export enum EExternalAccountProviders {
  sber_business = 'sber_business',
}

export enum EDateTimeType {
  interval = 'interval',
  determined = 'determined',
  none = 'none',
}

export enum ERegionType {
  область = 'область',
  край = 'край',
  республика = 'республика',
  город = 'город',
  'автономный округ' = 'автономный округ',
  'автономная область' = 'автономная область',
}

export const enum ESubjectType {
  country = 'country',
  federal = 'federal',
  locality = 'locality',
  region = 'region',
}

export const enum EFederalDistrictCode {
  DVFO = 'DVFO',
  SZFO = 'SZFO',
  UFO = 'UFO',
  CFO = 'CFO',
  SFO = 'SFO',
  PFO = 'PFO',
  URFO = 'URFO',
  SKFO = 'SKFO',
}

export enum ENotificationChannel {
  email = 'email',
  webPush = 'webPush',
}

export enum ETenantSubscriptionStatus {
  active = 'active',
  finished = 'finished',
}

export enum EmployeeViewSettingsField {
  ordersColumns = 'ordersColumns',
  executionRequestsExecutorColumns = 'executionRequestsExecutorColumns',
}

export const enum EServiceFeePolicy {
  /** Транзакции оплачивает исполнитель */
  carrierPay = 'carrier_pay',
  /** Транзакции оплачивает заказчик */
  shipperPay = 'shipper_pay',
}

export enum EExperimentalFeatures {
  /** Доступ к разделу Согласования */
  approvals = 'approvals',
  /** Доступ разделу Документооборот */
  operationalDocuments = 'operationalDocuments',
  /** Возможность выгрузки заказов в Excel */
  ordersExport = 'ordersExport',
  /** Возможность загрузки заказов в Excel */
  ordersImport = 'ordersImport',
  /** Кастомизация справочника инцидентов */
  runIncidentsCustomization = 'runIncidentsCustomization',
  /** Отображение кастомной БЛ в этапах автоматизации */
  showAutomationStepLogic = 'showAutomationStepLogic',
  /** Скрытие лого, которое нужно для демо на с 29.02 */
  hideLogo = 'hideLogo',
  /**  Ролевая модель сибур */
  siburAdditionalRolesModel = 'siburAdditionalRolesModel',
  /** Возможность забрать часть объема по подбору */
  divisibleReduction = 'divisibleReduction',
  /** Отображение нового дизайна карточки рейса */
  runPreviewRedesign = 'runPreviewRedesign',
  /** Ценообразование подборов */
  executorsLookupsPricingModel = 'executorsLookupsPricingModel',
  /** Назначение логистов на заказы клиента */
  executorResponsibleEmployee = 'executorResponsibleEmployee',
  /** Персонализированные уведомления для конкретных лиц */
  notifyOnlyForResponsibleEmployees = 'notifyOnlyForResponsibleEmployees',
  /** Рефакторинг websocket контроллера */
  refactoringWebsocketController = 'refactoringWebsocketController',
  /** Изменение эндпоинтов получения и отправки документов */
  operatorToConnectionUid = 'operatorToConnectionUid',
  /** Временный административный доступ от имени сотрудника клиента */
  temporaryAccessSessions = 'temporaryAccessSessions',
  /** Пагинация автокомплита списка водителей */
  driversPagination = 'driversPagination',
  /** Интерфейс ГВ в дровере торгов | Обновление таблицы участников */
  updatingLookupParticipants = 'updatingLookupParticipants',
  /** Добавить возможность скачать шаблон файла импорта заказов */
  downloadOrdersImportTemplate = 'downloadOrdersImportTemplate',
  /** Ролевая для ЭДО и Реестров */
  rolesForEdmAndRegistries = 'rolesForEdmAndRegistries',
  /** Добавить возможность запускать автоматизацию вручную на доступный к подбору объем заказа */
  partialQuotaDistribution = 'partialQuotaDistribution',
  /* Доработки доплат для одиночных заказов (удаление отображение стоимости ДУ) */
  removeExtraServicesFromOrderInfo = 'removeExtraServicesFromOrderInfo',
  /** Автокомплит цен из матриц во все заказы группового заказа */
  combinedOrderPricesAutocomplete = 'combinedOrderPricesAutocomplete',
  /** Обновление логики работы с НДС */
  vatRatesV2 = 'vatRatesV2',
  /** Добавить push уведомления в TMS */
  showPushNotification = 'showPushNotification',
  /* Действия для выбора победителя в тендере */
  tenderWinners = 'tenderWinners',
  /* Валидация ставок относительно целевой ставки */
  tendersBidPriceLimit = 'tendersBidPriceLimit',
  /** Доработки по открытому рынку */
  openTrade = 'openTrade',
  /** Рефакторинг метода saveTableSettings у таблиц */
  refactoringMethodSaveTableSettings = 'refactoringMethodSaveTableSettings',
  /** Включает колонку подразделений в таблице заявок */
  departmentColumnInExecutionRequests = 'departmentColumnInExecutionRequests',
  /* Реализовать в админке импорт на добавление контрагента с настроенной ЦО */
  tenantContractorsInfo = 'tenantContractorsInfo',
  /* Добавить поле внешний номер на связку адреса и контрагента и доработать UI на точке маршрута */
  contractorAddressExternalNumber = 'contractorAddressExternalNumber',
  /* Изменение логики привязки ЦО к точке маршрута в заказе */
  transitPointDigitalQueue = 'transitPointDigitalQueue',
  /** Рефакторинг хелпера для ячеек в CustomTableLayout */
  refactoringGetCellComponentByType = 'refactoringGetCellComponentByType',
  /** Добавление доп. получателей в ЭТрН */
  extraRecipientsSupport = 'extraRecipientsSupport',
  /** Отображается ошибка при попытке перейти по защищенному маршруту */
  fixRebuildRejectedProtectedRoutes = 'fixRebuildRejectedProtectedRoutes',
  /** Рефакторинг компонента создания тенанта и настроек организации (AddTenantDrawer и TenantSettingsCard) */
  refactoringAddTenantForm = 'refactoringAddTenantForm',
  /** Перенос предварительных бронирований в резервирования */
  prebookingReservedSlots = 'prebookingReservedSlots',
  /** Добавить в справочник "Условие поставки" значение DOOR */
  doorDeliveryTerm = 'doorDeliveryTerm',
  /** Исправление отправки множественных запросов к PATCH /session */
  fixCheckAndUpdateSession = 'fixCheckAndUpdateSession',
}

export enum ECompanyRole {
  executor = 'executor',
  customer = 'customer',
  shipper = 'shipper',
}

export const ADDRESS_SOURCES = {
  daData: 'da_data',
  db: 'db',
  user: 'user',
};

export enum EAddressSources {
  daData = 'da_data',
  imported = 'imported',
  user = 'user',
  integration = 'integration',
}

export const SUPPORT_EMAIL = 'support@tms.ru';

export enum EStatusType {
  default = 'default',
  error = 'error',
  processing = 'processing',
  success = 'success',
  warning = 'warning',
}

export enum ERunWorkflowPhase {
  waitingForExecution = 'waiting_for_execution',
  executionInProgress = 'execution_in_progress',
  executionFinished = 'execution_finished',
  executionCancelled = 'execution_cancelled',
}

export enum ETenantType {
  customer = 'customer',
  executor = 'executor',
  shipper = 'shipper',
}

export enum EAddressBound {
  country = 'country',
  region = 'region',
  area = 'area',
  city = 'city',
  settlement = 'settlement',
  street = 'street',
  block = 'block',
}

export enum ERouteProgress {
  allProgress = 'all_progress',
  selfProgress = 'self_progress',
}

export enum EAdmissionToLookupsParticipation {
  noContractsNeeded = 'no_contracts_needed',
  contractStrictlyRequired = 'contract_strictly_required',
  followingByLookupSettings = 'following_by_lookup_settings',
}

export enum ECreationLookupType {
  strategy = 'strategy',
  manually = 'manually',
}

export enum EAutomationStepsSpotOfferAttributes {
  accessLevel = 'accessLevel',
  currency = 'currency',
  priceSource = 'priceSource',
  vatRate = 'vatRate',
  accessRules = 'accessRules',
  duration = 'duration',
  price = 'price',
  priceType = 'priceType',
}

export enum EAutomationStepsTargetOfferAttributes {
  currency = 'currency',
  priceSource = 'priceSource',
  vatRate = 'vatRate',
  duration = 'duration',
  price = 'price',
  partnershipId = 'partnershipId',
}

export enum EAutomationStepsQuotaAttributes {
  currency = 'currency',
  priceSource = 'priceSource',
  vatRate = 'vatRate',
  duration = 'duration',
  guaranteeTagName = 'guaranteeTagName',
  quotaAccountingType = 'quotaAccountingType',
  price = 'price',
  pricingModel = 'pricingModel',
}

export enum EAutomationStepsReductionAttributes {
  accessLevel = 'accessLevel',
  currency = 'currency',
  offeringType = 'offeringType',
  priceSource = 'priceSource',
  vatRate = 'vatRate',
  accessRules = 'accessRules',
  duration = 'duration',
  percentStep = 'percentStep',
  exactStep = 'exactStep',
  expirationStartsAfter = 'expirationStartsAfter',
  manualBidSelection = 'manualBidSelection',
  manualBidSelectionDuration = 'manualBidSelectionDuration',
  startingPrice = 'startingPrice',
  stepType = 'stepType',
  automaticProlongation = 'automaticProlongation',
  buyNowEnabled = 'buyNowEnabled',
  buyNowPercent = 'buyNowPercent',
}

export enum EAutomationStepsFreeOfferingAttributes {
  accessLevel = 'accessLevel',
  currency = 'currency',
  maxPrice = 'maxPrice',
  minPrice = 'minPrice',
  offerSelectionDuration = 'offerSelectionDuration',
  offeringDuration = 'offeringDuration',
  offeringType = 'offeringType',
  priceSource = 'priceSource',
  vatRate = 'vatRate',
  accessRules = 'accessRules',
  automaticProlongation = 'automaticProlongation',
}

export enum ELookupUsageContext {
  order = 'order',
  agreement = 'agreement',
}

export const MORE_INFO_ABOUT_UPLOADING_ORDERS_STATUSES_URL = 'https://confluence.trucker.group/manual/7-11-massovoe-izmenenie-statusov-rejsov-2585069172.html';
export const MORE_INFO_ABOUT_MOVE_ORDERS_URL = 'https://confluence.trucker.group/pages/viewpage.action?pageId=2585067650';

export const MORE_INFO_ABOUT_PLANS_URL = 'https://confluence.trucker.group/manual/9-tarify-i-usloviya-2535822689.html';

/** Ссылка на договор офферты для подписки на кабинет ГВ (грузовладельца) */
export const CARGO_OWNER_PUBLIC_OFFER_LINK = '/docs/default/contract-offer-customer.pdf';
/**  Ссылка на договор офферты для подписки на кабинет ГП (грузоперевозчик) или кабинет ГО/ГП (грузоотправитель/грузополучатель) */
export const CARRIER_PUBLIC_OFFER_LINK = '/docs/default/contract-offer.pdf';

/**
 * Ссылка на инструкцию по кнопке (опции) "Забрать сразу" для ГП
 * */
export const MORE_INFO_ABOUT_BUY_NOW_FOR_CARRIER = 'https://confluence.trucker.group/manual/6-2-1-1-knopka-zabrat-srazu-2565683747.html';

export const COUNT_OF_BILLING_TRIAL_PERIOD_DAYS = 14;

export const DEFAULT_SORT_BY_PARAM = 'status_and_booking_or_registered_timestamp';

export enum EDocumentTypeForRuns {
  deliveryNote = 'delivery_note',
  expeditorAgentReceipt = 'expeditor_agent_receipt',
  materialLoadList = 'material_load_list',
  other = 'other',
  powerOfAttorney = 'power_of_attorney',
  general = 'general',
}

export enum EDriverFormField {
  fullName = 'fullName',
  birthday = 'birthday',
  birthplace = 'birthplace',
  passportNumber = 'passportNumber',
  passportIssuedOn = 'passportIssuedOn',
  passportIssuedBy = 'passportIssuedBy',
  registrationAddress = 'registrationAddress',
  phone = 'phone',
  inn = 'inn',
}

export enum EPowerOfAttorneyFormField {
  powerOfAttorneyNumber = 'powerOfAttorneyNumber',
  powerOfAttorneyIssuedOn = 'powerOfAttorneyIssuedOn',
  powerOfAttorneyInfo = 'powerOfAttorneyInfo',
  bookingDocuments = 'bookingDocuments',
}

export enum ETruckFormField {
  truckLicensePlate = 'truckLicensePlate',
  truckBrand = 'truckBrand',
  truckOwnership = 'truckOwnership',
  ownershipDocument = 'ownershipDocument',
  executorName = 'executorName',
  executorInn = 'executorInn',
  contractNumber = 'contractNumber',
  contractSignedOnDate = 'contractSignedOnDate',
  truckForwarderExecutor = 'truckForwarderExecutor',
  truckForwarderExecutorInn = 'truckForwarderExecutorInn',
  truckForwarderContract = 'truckForwarderContract',
  truckForwarderContractIssuedOn = 'truckForwarderContractIssuedOn',
}

export enum ETrailerFormField {
  trailerLicensePlate = 'trailerLicensePlate',
  trailerBrand = 'trailerBrand',
  trailerOwnership = 'trailerOwnership',
  ownershipDocument = 'ownershipDocument',
  executorName = 'executorName',
  executorInn = 'executorInn',
  contractNumber = 'contractNumber',
  contractSignedOnDate = 'contractSignedOnDate',
  trailerForwarderExecutor = 'trailerForwarderExecutor',
  trailerForwarderExecutorInn = 'trailerForwarderExecutorInn',
  trailerForwarderContract = 'trailerForwarderContract',
  trailerForwarderContractIssuedOn = 'trailerForwarderContractIssuedOn',
}

export enum EOwnershipType {
  own = 'own',
  rent = 'rent',
}

export const INCOTERMS = ['EXW', 'FCA', 'CPT', 'CIP', 'DAT', 'DAP', 'DDP', 'FAS', 'FOB', 'CFR', 'CIF', 'DDU', 'DAF', 'DEQ', 'DES'];

export enum ETableCellAutoRenderType {
  string = 'string',
  integer = 'integer',
  float = 'float',
  boolean = 'boolean',
  tenant = 'tenant',
  expectedArrivalTime = 'expected_arrival_time',
  array = 'array',
  employee = 'employee',
  packaging = 'packaging',
  vehicleCapacity = 'vehicle_capacity',
  money = 'money',
  transport = 'transport',
  date = 'date',
}
